import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/dropdown';

// module import is handled by webpack.mix.js

$.fn.isInViewport = function() {
	if($(this).offset() !== undefined ){
		var elementTop = $(this).offset().top;
	    var elementBottom = elementTop + $(this).outerHeight();

	    var viewportTop = $(window).scrollTop();
	    var viewportBottom = viewportTop + $(window).height();

	    return elementBottom > viewportTop && elementTop < viewportBottom;
	}

};